import { MatDialog } from '@angular/material/dialog';
import { FORM_TEXTS } from './../../../campaign/components/objects/placeholder';
import { EventsService } from './../../../shared/services/events/events.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, lastValueFrom } from 'rxjs';
import { SignupService } from '../../../shared/services/signup/signup.service';
import { UtilService } from './../../../shared/services/util/util.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { VariablesService } from './../../../shared/services/variables/variables.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthService, PusherService, ScriptLoaderService, SeoService, VwoService } from '../../../shared/services';
import { ISystemEvent } from '../../../shared/models';
import { environment } from '../../../../environments/environment';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPhoneNumber } from 'firebase/auth';
import { StartAFrUrls } from 'src/app/shared/models/start-fr-urls';

@Component({
  selector: 'app-sac-signup',
  templateUrl: './sac-signup.component.html',
  styleUrls: ['./sac-signup.component.scss']
})
export class SacSignupComponent implements OnInit, OnDestroy {

  public purpose;
  public form: FormGroup;
  public emailForm: FormGroup;
  public otpForm: FormGroup;
  languageForm: FormGroup;
  name: FormControl;
  email: FormControl;
  mobile: FormControl;
  password: FormControl;
  captcha: FormControl;
  otp: FormControl;
  email_otp: FormControl;
  emailCheck: FormControl;
  language: FormControl;
  private subs: Subscription = new Subscription();
  isLoggedInSub;
  @ViewChild('captchaSignUp') captchaSignUp;
  @ViewChild('askEmail') askEmail;
  response;
  dockFrData;
  isLoading;
  isLoadingEmail;
  extn;
  hideNGO = false;
  formInfo;
  accessToken = '';
  stageOtp = false;
  currentLanguage: any;
  req_nonce;
  checkforFOS = true;
  acceptedTrueCallerAuth = false;
  allSubs: Subscription[] = [];

  public languages = [
    { label: 'हिंदी', value: 'Hindi' },
    { label: 'English', value: 'English' },
    { label: 'తెలుగు', value: 'Telugu' },
    { label: 'தமிழ்', value: 'Tamil' },

  ];

  validLanguages = ['en', 'hi', 'ta', 'te'];

  languageCodes = {
    en: 'English',
    hi: 'Hindi',
    te: 'Telugu',
    ta: 'Tamil'
  };

  isLanguageSelected: any;
  isFOSSACLoading = false;

  formData: any;
  switchEmailLogin = false;
  startAFrUrls = StartAFrUrls;

  constructor(
    public vars: VariablesService,
    private authService: AuthService,
    private util: UtilService,
    private signupService: SignupService,
    private actRoute: ActivatedRoute,
    private events: EventsService,
    private router: Router,
    public vwo: VwoService,
    private pusherService: PusherService,
    private scriptLoader: ScriptLoaderService,
    private seoService: SeoService,
    private dialog: MatDialog
  ) {
    if (!this.actRoute.snapshot.queryParams.saf_source) {
      this.router.navigate([], { queryParams: { saf_source: this.vars.pageName }, queryParamsHandling: 'merge' });
    }
  }

  ngOnInit() {
    this.currentLanguage = this.util.storage.get('language') || 'English';
    this.isLanguageSelected = Boolean(this.util.storage.getFromSession('isLanguageSelected')) || false;
    this.initForm();
    this.initLanguageForm();

    this.checkIfFosIsUser();
    this.setLanguage();
  }

  normalFlow() {
    this.checkForFos();
    this.vars.pageName = 'sac-signup';
    this.loggedInRedirect();
    if (typeof document !== 'undefined') {
      document.body.classList.add('bg-grey');
    }
    this.setHeader();
    this.setCampaignPurpose();
    this.setCanonicalUrl();
    this.prefillForm();
    this.getPhoneExtn();

    this.checkForLanguage();
  }

  async checkIfFosIsUser() {
    this.isFOSSACLoading = true;
    const u_auth = this.util.cookie.getCookie('u_auth');
    const admin_u_auth = this.util.cookie.getCookie('admin_u_auth');

    if (admin_u_auth && u_auth) {
      const adminUserData: any = await lastValueFrom(this.getUserDataViaAuth(admin_u_auth));
      const userdata: any = await lastValueFrom(this.getUserDataViaAuth(u_auth));
      if (userdata && adminUserData && adminUserData?.data?.id === userdata?.data?.id) {
        // logging in user so that he can log out via header
        this.util.isLoggedIn.next(true);
        this.util.openSnackBar('Please logout from ketto or open in incognito mode', 'DISMISS');
        this.router.navigate(['/'], {queryParamsHandling: 'merge'});
        if (this.util.isBrowser) {
          setTimeout(() => {
            this.isFOSSACLoading = false;
          }, 800);
        }
      } else {
        this.normalFlow();
      }
    } else {
      this.normalFlow();
    }
  }

  getUserDataViaAuth(auth) {
    try {
      return this.authService.loginViaUAuth(auth);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  checkForLanguage() {
    const qParams = this.actRoute.snapshot.queryParams;
    if (qParams['lang'] && this.validLanguages.includes(qParams['lang'])) {
      this.currentLanguage = this.languageCodes[qParams['lang']];
      this.util.storage.check('language', this.currentLanguage);
    }
  }

  checkForFos() {
    this.util.isLoggedIn$.subscribe(res => {
      const U_AUTH = this.util.cookie.getCookie('admin_u_auth');
      if (U_AUTH && !res && this.checkforFOS) {
        this.checkforFOS = false;
        this.authService.loginViaUAuth(U_AUTH).subscribe((res1: any) => {
          this.authService.userLogin({ user: res1.data, token: U_AUTH });
          this.vars.isFOS = res1.data.is_fos;
          if (this.vars.isFOS) {
            this.isFOSSACLoading = false;
            this.vars.adminToken = U_AUTH;
            this.openDialogWithTemplateRef(this.askEmail);
          } else {
            this.isFOSSACLoading = false;
          }
        });
      } else {
        this.isFOSSACLoading = false;
      }
    });
  }

  verifyEmail() {
    this.isLoadingEmail = true;
    if (this.emailForm.valid) {
      this.signupService.verifyEmail({
        'email': this.emailCheck.value
      }).subscribe({next:(res: any) => {
        this.authService.userLogin({ user: res.data, token: res.data.token });
        res.data.token = this.vars.adminToken;
        this.util.setUser(res.data);
        setTimeout(() => {
          this.isLoadingEmail = false;
          this.closeDialog();
          this.util.router.navigate(['/new/crowdfunding/medical'], {queryParamsHandling: 'merge'});
        }, 1000);
      }, error: () => {
        this.email.setValue(this.emailCheck.value);
        this.closeDialog();
      }});
    } else {
      this.isLoadingEmail = false;
      this.util.checkValidForm(this.form);
    }
  }

  openDialogWithTemplateRef(templateRef) {
    this.dialog.open(templateRef, {
      width: '350px',
      height: '233px',
      panelClass: 'ask-number'
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  private loggedInRedirect() {
    this.isLoggedInSub = this.util.isLoggedIn.subscribe(async (res) => {
      if (res) {
        if (typeof window !== 'undefined' && window.location.pathname.includes('new/crowdfunding')) {
          this.signupService.userData = this.util.getUserData();
          this.signupService.response = { data: this.util.getUser() };
          const qparams = { type: this.vars.campaignPurpose };
          const isDraftExist = await this.signupService.checkForDraft(false);
          if (isDraftExist) {
            this.signupService.draftRedirection();
          } else {
            const url = this.purpose === 'medical' ? this.startAFrUrls.medical : this.startAFrUrls['non-medical'];
            this.router.navigate([url], { queryParams: qparams, queryParamsHandling: 'merge' });
          }
        }
      } else {
        const qparams = this.actRoute.snapshot.queryParams;
        // if from mcd app sac opens disable truecaller
        if (qparams && qparams.frm && qparams.frm === 'app') {
          return;
        }
        if (this.util.isMobile() && this.util.getMobileOperatingSystem() !== 'iOS') {
          this.setTruecallerConfig();
        }
      }
    });
    if (typeof window !== 'undefined') {
      this.pageviewEvent();
    }
  }

  private setCanonicalUrl() {
    if (this.purpose === 'medical') {
      this.seoService.updateCanonicalURL('/cause/medical-fundraising');
    }
  }

  private setTruecallerConfig() {
    this.req_nonce = new Date().valueOf();
    this.vars.req_nonce = this.req_nonce;
    this.authService.trueCallerAuth(this.req_nonce);
    this.scriptLoader.load('pusher').then(() => {
      this.pusherService.pusher('phoneverification', 'truecaller');
      this.pusher('phoneverification');
    });
  }

  private setCampaignPurpose() {
    const type = this.actRoute.snapshot.queryParams['type'];
    const frTypeArr = ['medical', 'ngo', 'other'];
    if (type && frTypeArr.includes(type)) {
      this.purpose = type;
    } else if (this.vars.campaignPurpose) {
      this.purpose = this.vars.campaignPurpose;
    } else {
      this.purpose = 'medical';
    }
    const onlyNgo = this.actRoute.snapshot.queryParams['onlyNgo'];
    if (onlyNgo) {
      this.hideNGO = true;
    }
  }

  private prefillForm() {
    this.dockFrData = this.util.storage.getFromSession('dockCampaignerData');
    if (this.dockFrData) {
      this.form.patchValue({
        'name': this.dockFrData.name,
        'mobile': this.dockFrData.extension + this.dockFrData.mobile,
        'email': this.dockFrData.email || ''
      });
    }
  }

  private setHeader() {
    this.vars.mainLayoutConfig.next({
      showHeader: this.util.isMobile() ? false : true,
      showFooter: false,
      showMenus: false,
      showProfile: false,
      showSearch: false,
      logoNavigate: true,
      animateHeader: true,
      headerTopSticky: false,
      headerClass: 'sac-signup-header'
    });
  }

  private initForm() {
    this.form = new FormGroup({
      name: this.name = new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-z ,.'-]+$/i),
      ]),
      email: this.email = new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.pattern(this.vars.email_Pattern_Regex)
      ]),
      mobile: this.mobile = new FormControl('', [
        Validators.required
      ]),
      password: this.password = new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(this.vars.psw_Pattern_Regex)
      ]),
      captcha: this.captcha = new FormControl('', [Validators.required]),
    });
    this.otpForm = new FormGroup({
      otp: this.otp = new FormControl('', [
        Validators.required,
        Validators.minLength(4),
      ]),
      mobile: new FormControl(this.mobile, [
        Validators.required
      ])
    });
    this.email_otp = new FormControl('', [
      Validators.required,
      Validators.minLength(4),
    ]);

    this.emailForm = new FormGroup({
      emailCheck: this.emailCheck = new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.pattern(this.vars.email_Pattern_Regex)
      ]),
    });
  }

  private initLanguageForm() {
    this.languageForm = new FormGroup({
      language: this.language = new FormControl(this.currentLanguage)
    });
  }

  selectLanguage(event) {
    this.isLanguageSelected = true;
    this.changeLanguage(event);
  }

  patchForm(data) {
    this.form.get('mobile').disable();
    this.form.patchValue({
      name: data.name || '',
      email: data.email || '',
      mobile: data.phone || '',
    });
  }

  getPhoneExtn() {
    this.util.number$.subscribe(res => {
      this.extn = res.extn;
      this.mobile.setValue(res.number);
    });
  }


  signupFOS() {
    this.form.removeControl('captcha');
    if (this.isLoading) {
      return true;
    }
    if (this.form.valid) {
      this.isLoading = true;
      const formData = {
        formValues: this.form.getRawValue(),
        user_type: 'individual',
      };
      formData.formValues.extn = this.extn;
      formData.formValues.callback = this.signUpCB;
      formData.formValues.startFrType = this.purpose;
      formData.formValues.accessToken = '';
      this.signupService.signupFOS(formData).then(res => {
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
      this.util.checkValidForm(this.form);
    }
  }

  signup(formValues) {
    if (this.isLoading) {
      return true;
    }
    if (this.vars.isFOS) {
      this.signupFOS();
      return true;
    }
    if (this.switchEmailLogin && this.otpForm.valid) {
      this.emailLogin();
      return;
    }
    this.captchaSignUp.executeCaptcha();

    // Check since lead getting called twice because of 'captchaResolvedObs'
    let leadCalled = false;
    this.subs = this.captchaSignUp.captchaResolvedObs.subscribe({
      next: (data) => {
        if (data !== null && data !== '') {
          this.isLoading = true;
          this.captcha.setValue(data);
          if (this.form.valid) {
            this.formData = {
              formValues: {
                ...this.form.getRawValue(),
                extn: this.extn,
                callback: this.signUpCB,
                startFrType: this.purpose,
                accessToken: ''
              },
              user_type: 'individual',
            };

            // Flow with OTP
            if (!this.stageOtp && !this.acceptedTrueCallerAuth) {
              if (!leadCalled) {
                this.verifyUserExist('phone');
              }
              leadCalled = true;
              return true;
            }

            // On click of next after entering OTP
            if (!this.acceptedTrueCallerAuth) {
              if (!this.otpForm.valid) {
                this.util.checkValidForm(this.otpForm);
                this.isLoading = false;
                return true;
              }
              const otpData = {
                'otp': this.otp.value
              };
              this.verifyUserOTP(otpData);
            } else {    // FLow without  OTP - normal flow
              this.callSignupAPI();
            }
          } else {
            this.isLoading = false;
            this.util.checkValidForm(this.form);
          }
          this.subs.unsubscribe();
          this.captchaSignUp.resetCaptcha();
        } else {
          this.isLoading = false;
        }
      },
      error: (err) => {
        this.captchaSignUp.resetCaptcha();
        this.isLoading = false;
        this.subs.unsubscribe();
      }
    });
  }
  // API Call for signup
  callSignupAPI(allowMultipleLeads?, otpStep1?) {
    if (this.stageOtp) {
      this.sendSystemEvent('sac_otp_entered');
    }
    if (otpStep1) {
      this.getOTPfromFirebasePhone();
      this.vars.pageName = 'sac_verify_mobile_number';
      this.pageviewEvent();
      this.stageOtp = true;
      this.isLoading = false;
      this.captchaSignUp.resetCaptcha();
    } else {
      this.signupService.signup(this.formData, allowMultipleLeads, otpStep1).then(
        (res) => {
          this.isLoading = false;
          this.captchaSignUp.resetCaptcha();
        },
        (err) => {
          if (err.error.message === 'User Not Found') {
            this.verifyUserExist('email');
          } else {
            this.isLoading = false;
          }
          this.captchaSignUp.resetCaptcha();
        }
      );
    }
  }

  verifyUserExist(type: 'phone' | 'email') {
    let payload = {};
    if (type === 'phone') {
      payload = {
        phone: this.mobile.value,
        extension: this.extn,
        showError: 'false'
      };
    }
    if (type === 'email') {
      payload = {
        email_id: this.email.value,
        showError: 'false'
      };
    }
    this.authService.verifyUserDetails(payload).subscribe({
      next: resp => {
        if (type === 'phone') {
          if (!this.otpForm.get('mobile') || !this.otpForm.get('otp')) {
            this.otpForm.addControl('mobile', this.mobile);
            this.otpForm.addControl('otp', this.otp);
            this.otpForm.removeControl('email');
            this.otpForm.removeControl('email_otp');
          }
          this.callSignupAPI(false, true);
        } else if (type === 'email') {
          if (!this.otpForm.get('email_otp') || !this.otpForm.get('email')) {
            this.otpForm.addControl('email', this.email);
            this.otpForm.addControl('email_otp', this.email_otp);
            this.otpForm.removeControl('mobile');
            this.otpForm.removeControl('otp');
          }
          this.stageOtp = true;
          this.switchEmailLogin = true;
          this.util.openSnackBar('OTP has been sent to your email ' + this.email.value, 'success');
        }
        this.isLoading = false;
      },
      error: err => {
        if (type === 'phone' && err?.error?.message === 'Invalid details') {
          this.verifyUserExist('email');
        } else if (type === 'email' && err?.error?.message === 'Invalid details') {
          this.callSignupAPI(false, true);
        } else {
          this.util.openSnackBar(err?.error?.message, 'error');
        }
        this.isLoading = false;
      }
    });
  }

  signUpCB(signupStatus, res?) {
    this.isLoading = false;
    this.response = res;
    // this.captchaSignUp.resetCaptcha();
  }

  submitButton() {
    if (typeof document !== 'undefined') {
      document.getElementById('submitBtn1').click();
    }
  }

  openSigninPopup() {
    const qParams = {
      redirect_uri: (this.router.url).split('?')[0]
    };
    this.router.navigate(['/new/signin'], { queryParams: qParams, queryParamsHandling: 'merge' }).catch(() => { });
  }

  purposeSelectionEvent(data) {
    this.purpose = data;
    this.signupService.startFrType = data;
    this.vars.campaignPurpose = data;
  }


  sendSystemEvent(eventName) {
    const payload: ISystemEvent = {
      eventName: eventName,
      event_type: 'campaign',
      page_name: this.vars.pageName,
      info_1: 'type',
      // info_2: this.util.getCampaignTypeFromId(data.parent_cause_id),
      info_3: this.util.storage.get('language') || 'English',
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }
  /*Event tracking */
  pageviewEvent() {
    if (typeof document !== 'undefined') {
      const pageEvent = {
        eventName: 'pageView',
        page_name: this.vars.pageName,
        referrer_page: document.referrer
      };
      this.events.onLoadSystemEvent(pageEvent);
    }
  }

  setLanguage(data?) {
    const lang = this.util.storage.get('language');
    this.formInfo = lang ? FORM_TEXTS[lang] : FORM_TEXTS['English'];
  }

  changeLanguage(lang) {
    this.currentLanguage = lang;
    this.util.storage.check('language', this.currentLanguage);
    this.util.storage.addSessionData('isLanguageSelected', this.isLanguageSelected);
    this.setLanguage();
  }

  getOTPfromFirebasePhone(type?) {
    if (typeof window !== 'undefined') {
      if (!this.form.value.mobile || this.form.controls.mobile.invalid) {
        return true;
      }
      if (type === 'resend') {
        this.sendSystemEvent('sac_otp_resend_clicked');
      }
      const appVerifier = (<any>window).recaptchaVerifier;
      const phoneNo = this.mobile.value;
      // if (environment.production === false) {
      //   // All the otp on non-production will go to this number
      //   // OTP: 123456
      //   phoneNo = '9123456789';
      // }
      const auth = getAuth(initializeApp(environment.firebase));
      signInWithPhoneNumber(auth, this.extn + phoneNo, appVerifier).then(result => {
        this.isLoading = false;
        (<any>window).confirmationResult = result;
        this.util.openSnackBar('OTP has been sent to your number ' + phoneNo, 'success');
      }).catch(error => {
        this.isLoading = false;
        this.util.openSnackBar(error.message + ': ' + error.code, 'error');
      });
    }
  }

  /**
 * This verifies the OPT entered by the user
 * @param data OTP code
 */
  verifyUserOTP(data) {
    const self = this;
    this.isLoading = true;
    if (typeof window !== 'undefined') {
      (<any>window).confirmationResult.confirm(data.otp).then(result => {
        result.user.getIdToken().then(function (idToken) {
          self.formData['formValues']['firebase_response'] = result.user;
          self.formData.formValues.accessToken = idToken;
          self.callSignupAPI(true);
        });
        // this.payload['firebase_response'] = result.user;
        // this.verifyUserToken();
      }).catch(error => {
        this.isLoading = false;
        this.util.openSnackBar(error.message, 'error');
      });
    }
  }

  emailLogin() {
    const data = {
      email: this.email.value,
      email_id: this.email.value,
      otp: this.email_otp.value
    };
    this.isLoading = true;
    this.authService.loginOTPVerify(data).subscribe({
      next: async (resp) => {
        this.allSubs.push(this.vars.afterLoginRedirectsHit.subscribe(res => {
          if (res) {
            this.dialog.closeAll();
          }
        }));
        await this.signupService.sacAfterRegister(resp, this.formData?.formValues, false);
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
  }

  async pusher(channel) {
    this.pusherService.channelName = channel;
    const pusherChannel: any = await this.pusherService.pusherTruecallerObj.subscribe();
    pusherChannel.bind(channel, (event) => {
      if (!event.status && event.status !== 'user_rejected') {
        if (event.phone) {
          this.acceptedTrueCallerAuth = true;
          const phone = event.phone.toString();
          event.phone = phone.substring(phone.length - 10, phone.length);
          this.patchForm(event);
        }
      }
      // this.bottomSheet.dismiss();
    });
  }

  ngOnDestroy(): void {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('bg-grey');
    }
    this.allSubs.forEach(s => s.unsubscribe());
    if (this.isLoggedInSub) {
      this.isLoggedInSub.unsubscribe();
    }
  }

}
